<template>
    <div></div>
</template>

<script>
import { clearSsoSlug } from '@/utils/ssoSlug';

export default {
    created() {
        // The generic /login route is a deliberate reset (CORE-7425): forget any persisted
        // enterprise-SSO slug so this always starts the generic sign-in. It is the post-logout
        // landing and the recovery path for a browser already pinned to a customer.
        clearSsoSlug();
        window.auth.login();
    }
};
</script>
